export const links = {
  RGCamsMobile: "https://rpwmct.com/?siteId=wl3&cobrandId=257522&superCategoryName=&categoryName=&pageName=home&performerName=&prm[psid]=RedGIFs&prm[pstool]=205_1&prm[psprogram]=cbrnd&prm[campaign_id]=132150&subAffId={SUBAFFID}",
  // eslint-disable-next-line
  RGCamsDesktop: "https://rgcams.com/landing/click/?AFNO=1-11",
};
